export default __webpack_public_path__ + "static/media/Blade of Marred Spirits.9c99d1e5.jpg";